import { ArticleTile } from '@chaseweb/ui-library/src'
import { type FC } from 'react'

import { transformCategoryToLabel } from './utils'

export interface TileProps {
  variant: 'sm' | 'md' | 'lg'
  label: string
  title: string
  description?: string | React.JSX.Element | React.JSX.Element[]
  summary?: string
  image: React.JSX.Element
}

export const Tile: FC<TileProps> = ({
  variant,
  image,
  label,
  title,
  description,
  summary,
}) => (
  <ArticleTile.Root hasHoverEffect variant={variant} aria-hidden>
    <ArticleTile.ImageWrapper className="tw-relative tw-aspect-square">
      {image}
    </ArticleTile.ImageWrapper>
    <ArticleTile.Content>
      <ArticleTile.Label className="tw-capitalize">
        {transformCategoryToLabel(label)}
      </ArticleTile.Label>

      <ArticleTile.Title>{title}</ArticleTile.Title>

      {description && (
        <ArticleTile.Description>{description}</ArticleTile.Description>
      )}

      {summary && <ArticleTile.Summary>{summary}</ArticleTile.Summary>}
    </ArticleTile.Content>
  </ArticleTile.Root>
)
